<template>
    <div v-if="!reviewed && transfer_id" class="w-full flex flex-column relative py-1 align-items-center xl:align-items-start lg:align-items-start md:align-items-start gap-4">
        <div class="flex flex-row">
            <Button :label="content[lang_].good" icon="pi pi-check" iconPos="right" @click="good()"
                class="flex mr-2 border-round-2xl font-medium text-green-600 border-solid border-2" type="text" severity="secondary"
                :class="(feel=='good') ? 'bg-green-100 border-green-100' : 'border-0 surface-0'"/>
            <Button :label="content[lang_].bad" icon="pi pi-times" iconPos="right" @click="bad()"
                class="flex ml-2 border-round-2xl font-medium text-yellow-700 border-solid border-2" type="text" severity="secondary"
                :class="(feel=='bad') ? 'bg-yellow-400 border-yellow-400' : 'border-0 surface-0'"/>
        </div>
        
        <div v-if="!reviewed && feel" class="w-full flex flex-column xl:flex-row relative mt-3 align-items-left">
            <div class="w-full flex flex-column relative surface-0 gap-4 xl:mb-5
                xl:max-w-30rem lg:max-w-30rem md:max-w-30rem 
                border-round-xl xl:border-round-2xl" 
                :class="(padding) ? 'p-3' : ''">
                
                <!-- Good tags -->
                <div v-if="feel=='good'" class="w-full flex flex-column gap-3">
                    <span class="flex text-lg font-medium text-600">
                        {{ content[lang_].title_good }}
                    </span>
                    <div class="w-full">
                        <Button v-for="tag in review_tags_good[lang_]" 
                            @click="tag_pin(tag)" size="small"
                            :label="tag" class="mr-2 mb-2 border-round-2xl text-sm font-medium surface-0 border-solid border-2"
                            :class="(review_tags_selected.includes(tag)) ? 'border-green-200 text-green-600' : '' " severity="secondary"/>
                    </div>
                </div>

                <!-- Bad tags -->
                <div v-if="feel=='bad'" class="w-full flex flex-column gap-3">
                    <span class="flex text-lg font-medium text-600">
                        {{ content[lang_].title_bad }}
                    </span>
                    <div class="w-full">
                        <Button v-for="tag in review_tags_bad[lang_]" 
                        @click="tag_pin(tag)" size="small"
                        :label="tag" class="mr-2 mb-2 border-round-2xl text-sm font-medium surface-0 border-solid border-2"
                        :class="(review_tags_selected.includes(tag)) ? 'border-yellow-400 text-yellow-700' : ''" severity="secondary"/>
                    </div>
                </div>

                <!-- Comment -->
                <div v-if="review_tags_selected && review_tags_selected.length" 
                    class="w-full flex flex-column gap-3">
                    <span class="flex text-lg font-medium text-600">
                        {{ content[lang_].comment }}
                    </span>
                    <div class="w-full flex flex-column gap-1">
                        <Textarea  rows="5" cols="20" class="border-round-2xl border-300 text-sm p-2 border-2 font-medium w-full" 
                            :value="comment"
                            @input="comment = $event.target.value"
                            style="resize: none !important; font-family: inherit;"
                            />
                        <span class="flex text-xs font-medium text-600">
                            {{ content[lang_].comment_length }}
                            <i :class="(comment && comment.length>=10) ? 'pi pi-check-circle text-green-600 ml-2' : 'pi pi-times-circle text-red-600 ml-2'" class="text-xs"></i>
                        </span>
                    </div>
                </div>

                <div class="w-full flex flex-column surface-0 border-round-xl gap-3"> 
                    <div class="w-full flex flex-column">
                        <span class="flex text-sm font-medium text-600">
                            {{ content[lang_].title_public }}
                        </span>
                    </div>
                    <SelectButton v-model="activeTab" :options="types" optionLabel="label" optionValue="index" optionDisabled="disabled" dataKey="title" size="small">
                        <template #option="slotProps">
                            <span class="text-sm py-1 white-space-nowrap" :class="(slotProps.option.disabled) ? 'text-400' : 'text-600'">
                                {{ slotProps.option.label[lang_] }}
                            </span>
                        </template>
                    </SelectButton>
                </div>

                <!-- User info -->
                <div v-if="activeTab==0" class="w-full flex flex-column surface-0 border-round-xl gap-3"> 
                    <div class="w-full flex flex-column">
                        <span class="flex text-sm font-medium text-600">
                            {{ content[lang_].title_info }}
                        </span>
                    </div>

                    <div class="w-full flex flex-row">
                        <!-- <div class="flex">
                            <Avatar v-if="userPhoto" :image="userPhoto" shape="circle" size="small" class="mr-2" />
                            <Avatar v-else icon="pi pi-user" shape="circle" size="small" class="mr-2" />
                        </div> -->
                        <div class="flex flex-1 align-items-start gap-1">
                            <div class="relative">

                                <!--Avatar-->
                                <Chip v-if="userPhoto" @click="setContact('avatar')" :class="isActive('avatar') ? 'bg-primary': ''" class="pr-2 py-0 pl-0 m-0 mr-1 mb-2 vertical-align-top cursor-pointer">
                                    <div class="flex">
                                        <Avatar :image="userPhoto" class="surface-0 m-0" shape="circle"/>
                                    </div>
                                    <span class="text-xs font-medium" :class="isActive('avatar') ? 'text-white': 'text-600'">Аватар</span>
                                </Chip>

                                <!--TG-->
                                <Chip @click="setContact('telegram')" class="m-0 mr-1 mb-2 vertical-align-top cursor-pointer" :class="isActive('telegram') ? 'bg-primary': ''">
                                    <i class="pi pi-telegram" :class="isActive('telegram') ? 'text-white': 'text-400'"></i>
                                    <span class="text-xs font-medium" :class="isActive('telegram') ? 'text-white': 'text-600'">{{ contactTelegram ? '@'+contactTelegram : 'Telegram' }}</span>
                                </Chip>

                                <!--WA-->
                                <Chip @click="setContact('whatsapp')" class="m-0 mr-1 mb-2 vertical-align-top cursor-pointer" :class="isActive('whatsapp') ? 'bg-primary': ''">
                                    <i class="pi pi-whatsapp" :class="isActive('whatsapp') ? 'text-white': 'text-400'"></i>
                                    <span class="text-xs font-medium" :class="isActive('whatsapp') ? 'text-white': 'text-600'">{{ contactWhatsapp ? contactWhatsapp : 'WhatsApp' }}</span>
                                </Chip>

                                <!--INST-->
                                <Chip @click="setContact('instagram')" class="m-0 mr-1 mb-2 vertical-align-top cursor-pointer" :class="isActive('instagram') ? 'bg-primary': ''">
                                    <i class="pi pi-instagram" :class="isActive('instagram') ? 'text-white': 'text-400'"></i>
                                    <span class="text-xs font-medium" :class="isActive('instagram') ? 'text-white': 'text-600'">{{ contactInstagram ? '@'+contactInstagram : 'Instagram' }}</span>
                                </Chip>
                            </div>
                        </div>
                    </div>
                </div>

                <Button :label="content[lang_].send" @click="send_review()" :disabled="!isValid || loading" :loading="loading"
                    class="border-round-xl font-medium border-none" size="large" severity="success"/>
            </div>
        </div>
    </div>

    <!--POPUP TELEGRAM-->
    <Dialog class="w-full surface-100 border-none" modal 
        v-model:visible="popupTelegram" 
        :position="screenSize=='xs' ? 'bottom' : 'center'"
        :style="(screenSize=='xs' || screenSize=='sm' || screenSize=='md') ? {width: '100%!important', margin: '0!important', padding: '0!important'} : { width: 'auto' }" 
        :contentStyle="(screenSize=='xs' || screenSize=='sm' || screenSize=='md') ? { height: 'auto' } : { height: 'auto' }"
        :class="(screenSize=='xs') ? 'border-noround-bottom' : 'max-w-30rem'">

        <template #header>
            <span class="text-lg font-medium">Укажите ваш Telegram</span>
        </template>
     
        <div class="w-full flex">
            <InputText v-model="contactTelegram" placeholder="Telegram username" class="w-full border-radius-xl" size="large" />
        </div>

        <template #footer>
            <Button label="OK" icon="pi pi-check" class="w-full border-round-xl font-medium border-none" 
                @click="setContact('telegram'); popupTelegram=false; activeContacts.push('telegram');" 
                :disabled="!contactTelegram || contactTelegram.length<3" size="large" severity="success" />
        </template>
    </Dialog>

    <!--POPUP WA-->
    <Dialog class="w-full surface-100 border-none" modal 
        v-model:visible="popupWhatsapp" 
        :position="screenSize=='xs' ? 'bottom' : 'center'"
        :style="(screenSize=='xs' || screenSize=='sm' || screenSize=='md') ? {width: '100%!important', margin: '0!important', padding: '0!important'} : { width: 'auto' }" 
        :contentStyle="(screenSize=='xs' || screenSize=='sm' || screenSize=='md') ? { height: 'auto' } : { height: 'auto' }"
        :class="(screenSize=='xs') ? 'border-noround-bottom' : 'max-w-30rem'">

        <template #header>
            <span class="text-lg font-medium">Укажите ваш WhatsApp</span>
        </template>
     
        <div class="w-full flex">
            <InputText v-model="contactWhatsapp" placeholder="WhatsApp number" class="w-full border-radius-xl" size="large" />
        </div>

        <template #footer>
            <Button label="OK" icon="pi pi-check" class="w-full border-round-xl font-medium border-none" 
                @click="setContact('whatsapp'); popupWhatsapp=false; activeContacts.push('whatsapp');" 
                :disabled="!contactWhatsapp || contactWhatsapp.length<3" size="large" severity="success" />
        </template>
    </Dialog>

    <!--POPUP INST-->
    <Dialog class="w-full surface-100 border-none" modal 
        v-model:visible="popupInstagram" 
        :position="screenSize=='xs' ? 'bottom' : 'center'"
        :style="(screenSize=='xs' || screenSize=='sm' || screenSize=='md') ? {width: '100%!important', margin: '0!important', padding: '0!important'} : { width: 'auto' }" 
        :contentStyle="(screenSize=='xs' || screenSize=='sm' || screenSize=='md') ? { height: 'auto' } : { height: 'auto' }"
        :class="(screenSize=='xs') ? 'border-noround-bottom' : 'max-w-30rem'">

        <template #header>
            <span class="text-lg font-medium">Укажите ваш Instagram</span>
        </template>
     
        <div class="w-full flex">
            <InputText v-model="contactInstagram" placeholder="Instagram username" class="w-full border-radius-xl" size="large" />
        </div>

        <template #footer>
            <Button label="OK" icon="pi pi-check" class="w-full border-round-xl font-medium border-none" 
                @click="setContact('instagram'); popupInstagram=false; activeContacts.push('instagram');" 
                :disabled="!contactInstagram || contactInstagram.length<3" size="large" severity="success" />
        </template>
    </Dialog>
</template>

<script>
import Connect from '@/assets/js/Connect.js'
export default {
    name: 'AddReview',
    props: ['transfer_id', 'reviewed', 'padding'],
    data() {
        return {
            content: {
                ru: {
                    title: 'Вам понравилось?',
                    good: 'Отлично',
                    bad: 'Не очень',
                    title_good: 'Что вам понравилось?',
                    title_bad: 'Что вам не понравилось?',
                    title_info: 'Укажите один или несколько контактов',
                    title_public: 'Тип публикации',
                    comment: 'Напишите пару ласковых о нас?',
                    comment_length: '(мин. 10 символов)',
                    send: 'Отправить',
                    msg_success_title: 'Успех',
                    msg_success_text: 'Спасибо за отзыв!',
                    msg_error_title: 'Ошибка',
                    msg_error_text: 'Что-то пошло не так',
                },
                en: {
                    title: 'Did you like it?',
                    good: 'Great',
                    bad: 'Not really',
                    title_good: 'What did you like the most?',
                    title_bad: 'What did you not like?',
                    title_info: 'Please provide one or more contacts',
                    title_public: 'Review type',
                    comment: 'Write a couple of kind words about us?',
                    comment_length: '(min. 10 characters)',
                    send: 'Send',
                    msg_success_title: 'Success',
                    msg_success_text: 'Thank you for your review!',
                    msg_error_title: 'Error',
                    msg_error_text: 'Something went wrong',
                }
            },
            comment: '',
            review_tags_good: {
                ru: [
                    'Отличный сервис', 
                    'Быстро',
                    'Просто',
                    'Хорошая поддержка',
                    'Функционально',
                ],
                en: [
                    'Service', 
                    'Speed',
                    'Ease',
                    'Support',
                    'Functionality',
                ],
            },
            review_tags_bad: {
                ru: [
                    'Медленно', 
                    'Высокая комиссия',
                    'Плохая поддержка',
                    'Скудный функционал',
                    'Сложно',
                ],
                en: [
                    'Slow', 
                    'High commission',
                    'Bad support',
                    'Poor functionality',
                    'Difficult',
                ],
            },
            review_tags_selected: [],
            loading: false,
            feel: null,
            activeTab: 0,
            types: [
                {
                    "label": {
                        "en": "Public",
                        "ru": "Публично",
                    },
                    "index": 0
                },
                {
                    "label": {
                        "en": "Anonymous",
                        "ru": "Анонимно",
                    },
                    "index": 1
                },
            ],
            contactTypes: ['avatar','telegram', 'whatsapp', 'instagram'],
            activeContacts: [],
            contactAvatar: null,
            contactTelegram: null,
            contactWhatsapp: null,
            contactInstagram: null,
            popupTelegram: false,
            popupWhatsapp: false,
            popupInstagram: false,
        }
    },
    computed: {
        lang_() { return (this.$i18n.locale) ? this.$i18n.locale : 'ru' },
        screenSize() { return this.$store.getters.StateScreenSize },
        userPhoto: function () { return this.$store.getters.StateUserPhoto },
        userTelegram: function () { return this.$store.getters.StateTelegramUsername },
        userPhone: function () { return this.$store.getters.StateUserPhone },
        userPrefix: function () { return this.$store.getters.StateUserPrefix },
        isValid: function () { 
            if(!this.review_tags_selected || this.review_tags_selected.length==0) return false
            if(this.comment && this.comment.length<10) return false
            if(this.activeTab==0 && this.activeContacts.length==0) return false
            return true
        }
    },
    methods: {
        showMess(severity, summary, detail) {
            this.$toast.add({severity: severity, summary: summary, detail: detail, life: 3000});
        },
        tag_pin(tag){
            if(this.review_tags_selected.includes(tag)){
                this.review_tags_selected = this.review_tags_selected.filter(item => item !== tag)
            }else{
                this.review_tags_selected.push(tag)
            }
        },
        good(){
            this.feel = 'good'
            this.review_tags_selected = []
            this.comment = ''
        },
        bad(){
            this.feel = 'bad'
            this.review_tags_selected = []
            this.comment = ''
        },
        isActive(type){
            if(!type) return false
            return this.activeContacts && this.activeContacts.includes(type)
        },
        getPhoneNumber(){
            if(!this.userPhone) return null
            if(this.userPrefix) return `+${this.userPrefix}${this.userPhone}`
            return this.userPhone
        },
        setContact(type){
            if(!type) return false
            if(!this.contactTypes.includes(type)) return false
            if(this.isActive(type)){
                this.activeContacts = this.activeContacts.filter(item => item !== type)
            }else{
                switch(type){
                    case 'avatar': this.activeContacts.push(type); break;
                    case 'telegram': this.popupTelegram = true; break;
                    case 'whatsapp': this.popupWhatsapp = true; break;
                    case 'instagram': this.popupInstagram = true; break;
                }
            }
        },
        send_review(){
            this.loading = true
            const data = {
                transfer_id: this.transfer_id,
                comment: this.comment,
                tags: this.review_tags_selected,
                feel: this.feel,
                public: (this.activeTab==0) ? true : false, // 0 - public, 1 - anonymous
                photo_url: (this.activeContacts.includes('avatar')) ? this.contactAvatar : null,
                social: {
                    telegram: (this.activeContacts.includes('telegram')) ? this.contactTelegram : null,
                    whatsapp: (this.activeContacts.includes('whatsapp')) ? this.contactWhatsapp : null,
                    instagram: (this.activeContacts.includes('instagram')) ? this.contactInstagram : null,
                }
            }
            try {
                this.connect.send_review(data).then(res=>{
                    if(res.result){
                        this.$emit('reviewed')
                        this.showMess('success', this.content[this.lang_].msg_success_title, this.content[this.lang_].msg_success_text)
                        window.scrollTo({ top: 0, behavior: 'smooth' })
                    }else{
                        const errors = (res.errors) ? res.errors.join(', ') : ''
                        console.log('Error send review: ', errors)
                        this.showMess('error', this.content[this.lang_].msg_error_title, errors)
                    }
                })
            } catch {
                this.showMess('error', this.content[this.lang_].msg_error_title, this.content[this.lang_].msg_error_text)
            }
            this.loading = false
        },
    },
    beforeCreate() {
        this.connect = new Connect()
    },
    mounted() {
        if(this.userTelegram) {
            this.activeContacts = this.activeContacts.concat('telegram')
            this.contactTelegram = this.userTelegram
        }
        if(this.userInstagram) {
            this.activeContacts = this.activeContacts.concat('instagram')
            this.contactInstagram = this.userInstagram
        }
        if(this.userPhone) {
            this.activeContacts = this.activeContacts.concat('whatsapp')
            this.contactWhatsapp = this.getPhoneNumber()
        }
        if(this.userPhoto) {
            this.activeContacts = this.activeContacts.concat('avatar')
            this.contactAvatar = this.userPhoto
        }
    }
}
</script>